import LS_CONSTANTS from "../constants/LSConstants";

const clearAllLSData = () => {
  localStorage.removeItem(LS_CONSTANTS.LS_USER_DATA);
  localStorage.removeItem(LS_CONSTANTS.LS_USER_SESSION_DATA);
  localStorage.removeItem(LS_CONSTANTS.LS_TRANS_DATA)
};

const getUserDataFromLs = () =>
  JSON.parse(localStorage.getItem(LS_CONSTANTS.LS_USER_DATA)) || {};

const getUserSessionDataFromLs = () =>
  JSON.parse(localStorage.getItem(LS_CONSTANTS.LS_USER_SESSION_DATA)) || {};

const getTransDataFromLs = () =>
  JSON.parse(localStorage.getItem(LS_CONSTANTS.LS_TRANS_DATA)) || {};

export { clearAllLSData, getUserDataFromLs, getTransDataFromLs, getUserSessionDataFromLs };
